var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6278 21.1147V6.42433C29.6742 4.38854 27.3327 2.77029 24.7432 1.66643C22.1537 0.562575 19.3696 -0.00420087 16.5574 2.34406e-05V17.9618C19.123 18.9954 24.5094 20.7897 31.6278 21.1147Z",
    fill: "#CD2227"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.774 32.9517C35.8854 29.903 37.1477 26.3412 37.4302 22.636C36.2269 22.931 35.0055 23.1449 33.774 23.2765V32.9517Z",
    fill: "#CD2227"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5574 21.1636V41.9999C19.3696 42.0041 22.1537 41.4373 24.7432 40.3335C27.3327 39.2296 29.6742 37.6114 31.6278 35.5756V23.4371C27.6447 23.6023 22.6275 23.0899 16.5574 21.1636Z",
    fill: "#CD2227"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4742 20.1111C37.3118 16.1454 36.0282 12.3088 33.774 9.052V21.166C34.9731 21.166 36.2146 21.1272 37.4931 21.0323C39.5919 21.0031 43.5074 20.157 43.5074 20.157C41.6317 20.4511 38.9184 20.2542 37.4742 20.1111Z",
    fill: "#CD2227"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9402 0.147095V41.9992C13.9402 41.9992 7.17465 41.6252 3.02655 38.0659C3.02655 38.0659 5.2165 36.0699 6.28987 32.5723C7.36324 29.0747 6.85563 27.3571 6.00699 26.341C5.15836 25.3248 2.11584 22.5096 1.52808 18.7289C1.39214 17.9737 1.50136 17.5206 1.00554 17.8282C0.509714 18.1358 0.607936 17.98 0.633867 17.3664C0.659797 16.7527 0.441352 15.2819 0.117613 14.5006C-0.206126 13.7193 0.213477 13.1412 0.47514 13.1847C0.736803 13.2282 1.15798 13.4457 1.18234 13.1847C1.2067 12.9238 1.03775 1.32299 13.9402 0.147095Z",
    fill: "#115883"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0d7e5909365cb84fcde9e8d500f9195f.svg";
export { ForwardRef as ReactComponent };